import { Link } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"
import HomeProducts from "../components/HomeProducts"

const Products = () => {
  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <HomeProducts searchable />
    </GuestLayout>
  )
}

export default Products